<template>
<div class="home">
  <div class="panels">
    <!-- CATEGORIAS -->
    <!-- <qb-panel title="NAVEGUE POR CATEGORIA" class="qb-margin-right  qb-margin-top">
      <vue-element-loading :active="!this.categoriasPronto"/> -->
      <!-- url , 'descricao', 'preco', 'precoDesconto' 'adiciona' -->
        <!-- <card-group>
          <qb-card v-for="categoria in categorias" :key="categoria.id" :content="categoria">
            <template v-slot:image> 
              <img src="@/assets/sem-foto.png" alt="foto produto" />
            </template>
          </qb-card>
        </card-group> -->
        <!-- <p>sem itens para carregar </p>
    </qb-panel> -->

    <!-- produtos novidade -->
    <qb-panel title="NOVIDADES" class="qb-margin-top qb-panel-margin-right">
      <vue-element-loading :active="!this.produtosNovosPronto"/>
      <card-group v-if="produtosNovos">
        <qb-card v-for="(produto) in produtosNovos.products" :key="produto.id" :content="produto" v-on:card-click="show('novidades'+produto.id)">
          <template v-slot:image>
           <!-- <carousel :autoplay="false" :nav="false" :items="1" v-if="produto.images.length">
              <img v-for="(imagem, index) in produto.images" :key="index" :src="imagem" alt="foto produto" style="max-width: 100%;max-height: 80px;min-height: 80px;"/>
            </carousel>
            <img v-else src="@/assets/sem-foto.png" alt="foto produto" style="max-width: 100%;max-height: 80px;min-height: 80px;"/> -->
            <img v-if="produto.images.length" :src="produto.images[0]" alt="foto produto"/> 
            <img v-else src="@/assets/sem-foto.png" alt="foto produto" />
          </template>
          <button class="btn btn-primary qb-txt-lg btn-full" @click="show('novidades'+produto.id)">Adicionar</button>
        </qb-card>
      </card-group>
      <router-link v-if="produtosNovos" to="/lista/?novidades=true" class="qb-txt-md">Ver mais</router-link>
      <p v-else>Sem itens para exibir</p>
    </qb-panel>

    <!-- Ofertas -->
    <qb-panel title="OFERTAS" class="qb-margin-top">
      <vue-element-loading :active="!this.produtosPromocaoPronto"/>
      <card-group v-if="produtosPromocao">
        <qb-card v-for="produto in produtosPromocao.products" :key="produto.id" :content="produto" v-on:card-click="show('promocao'+produto.id)">
          <template v-slot:image>
            <!-- <carousel :autoplay="false" :nav="false" :items="1" v-if="produto.images.length">
              <img v-for="(imagem, index) in produto.images" :key="index" :src="imagem" alt="foto produto" style="max-width: 100%;max-height: 80px;min-height: 80px;"/>
            </carousel>
            <img v-else src="@/assets/sem-foto.png" alt="foto produto" style="max-width: 100%;max-height: 80px;min-height: 80px;"/> -->
            <img v-if="produto.images.length" :src="produto.images[0]" alt="foto produto"/> 
            <img v-else src="@/assets/sem-foto.png" alt="foto produto" />
          </template>
          <button class="btn btn-primary qb-txt-lg btn-full" @click="show('promocao'+produto.id)">Adicionar</button>
        </qb-card>
      </card-group>
      <router-link v-if="produtosPromocao" to="/lista/?ofertas=true" class="qb-txt-md">Ver mais</router-link>
      <p v-else>Sem itens para exibir</p>
    </qb-panel>
  </div>
    
  <div class="carousel">
  <vue-element-loading :active="!this.sliderPronto"/>
  <h2 class="qb-margin-left">Últimas compras</h2>
    <carousel  :autoplay="false" :nav="true" :items="7"  v-if="this.sliderPronto" :autoHeight="true" :margin="5" :responsive="{0:{items:1, nav:true, dots:true},521:{items:2}, 900:{items:3}, 1300:{items:4}, 1600:{items:6}}">
      <qb-card v-for="produto in ultimasCompras" :key="produto.id" :content="produto"  :slider="true" class="qb-margin-8" :onGrid="false" v-on:card-click="show('compras'+produto.id)">
        <!-- 
          <img src="@/assets/sem-foto.png" alt="foto produto" />
         -->
         <template v-slot:image>
            <img v-if="produto.images.length" :src="produto.images[0]" alt="foto produto" /> 
            <img v-else src="@/assets/sem-foto.png" alt="foto produto"/>
          </template>
          <button class="btn btn-primary qb-txt-lg btn-full" @click="show('compras'+produto.id)">Adicionar</button>
      </qb-card>
    </carousel>
  </div>
  
  <!-- MODAIS COMPRA -->
  <!-- MODAL ULTIMAS COMPRA -->
  <modal v-for="lastorder in ultimasCompras" :key="lastorder.id" :name="'compras'+lastorder.id" :adaptive="true" height="auto" :resizable="true" :scrollable="true" >
    <conteudo-modal-produto v-bind="lastorder" :idModal="'compras'+lastorder.id"/>
  </modal>
  <!-- MODAL PROMOCAO -->
  <modal v-for="promo in produtosPromocao.products" :key="promo.id" :name="'promocao'+promo.id" :adaptive="true" height="auto" :resizable="true" :scrollable="true"  >
    <conteudo-modal-produto v-bind="promo" :idModal="'promocao'+promo.id"/>
  </modal>

  <!-- MODAL Novidades -->
  <modal v-for="novidade in produtosNovos.products" :key="'N'+novidade.id" :name="'novidades'+novidade.id"  :adaptive="true" height="auto" :resizable="true" :scrollable="true" >
    <conteudo-modal-produto v-bind="novidade" :idModal="'novidades'+novidade.id"/>
  </modal>
</div>

</template>

<script>
import axios from "axios";
import { baseApiUrl, baseImage, userKey } from "@/global";
import { mapState } from "vuex";
import CardGroup from '@/components/card/card-group.vue';
import QbCard from '@/components/card/card.vue';
import ConteudoModalProduto from '../../components/modal/product-modal.vue';
import carousel from 'vue-owl-carousel';
import VueElementLoading from 'vue-element-loading';

export default {
  name: 'Home',
  components: {
    CardGroup,
    QbCard,
    ConteudoModalProduto,
    carousel,
    VueElementLoading
  },
  computed: mapState(['user']),
  data(){
    return{
      categorias: [],
      produtosNovos: [],
      produtosPromocao: [],
      ultimasCompras: [],
      sliderPronto: false,
      produtosNovosPronto:false,
      produtosPromocaoPronto:false,
      categoriasPronto:true,
      baseImage: baseImage,
      clienteID:'',
      vendedor: false
    }
  },
  methods: {
    carregaUltimasCompras(){
      axios.get(`${baseApiUrl}/products/LatestProductsPurchased/?id=${this.clienteID}`)
      .then(res => {
        this.ultimasCompras = res.data;
        this.sliderPronto = true;
        }).catch(() =>{
          //TODO
        })
    },
    carregaCategoria(){
        axios.get(`${baseApiUrl}/category/`)
      .then(res => {
          this.categorias = res.data;
          this.categoriasPronto = true;
        })
    },
    carregaProdutosNovos(){
      axios.get(`${baseApiUrl}/products/list/?news=true&id=${this.clienteID}`)
      .then(res => {
        this.produtosNovos = res.data;
        this.produtosNovosPronto = true;
        }).catch(() =>{
          this.produtosNovosPronto = true;
        })
    },
  carregaProdutosPromocao(){
    axios.get(`${baseApiUrl}/products/list/?offers=true&home=true&id=${this.clienteID}`)
    .then(res => {
      this.produtosPromocao = res.data;
      this.produtosPromocaoPronto = true;
      }).catch(() =>{
          this.produtosPromocaoPronto = true;
      })
  },
  show (id) {
        this.$modal.show(id);
    }
  },
  created(){
    const json = localStorage.getItem(userKey);
    const userData = JSON.parse(json);
    if(userData.tipoAcesso=="V"){
        this.vendedor = true;
        const cliente = JSON.parse(localStorage.getItem('cliente_vinculado'));
        this.clienteID = cliente.id;
    }
    //this.carregaCategoria();
    this.carregaProdutosNovos();
    this.carregaProdutosPromocao();
    this.carregaUltimasCompras();
  }
}
</script>

<style>
@media screen and (min-width: 1200px){
  .panels{
    display: flex;
  }
}

@media screen and (max-width: 900px) and (min-width: 600px) {
  .panels{
    width: 100%;
  }
}

@media screen and (max-width: 600px) {
  .panels{
    width: 100%;
  }
}
</style>
